module.exports = __webpack_public_path__ + "img/icon-question-rating-group.4f1952e2.svg";